import "./style.css";
import logo from "./../../assets/logo.png";

const Header = ({ showProducts }) => {
  return (
    <header>
      <img src={logo} alt="burger logo" />
      <form className="inputBar">
        <input
          type="text"
          className="searchInput"
          placeholder="Digitar Pesquisa"
          onKeyUp={() => {
            showProducts();
          }}
          />
          <button>Pesquisar</button>
      </form>
    </header>
  );
};

export default Header;
